// src/App.jsx
import React from "react";
import Routes from "./Routes";
import AppGate from "./components/system/AppGate"; // ⬅️ NUEVO

function App() {
  return (
    <AppGate>   {/* ⬅️ Bloquea toda la app del laboratorio */}
      <Routes />
    </AppGate>
  );
}

export default App;
